import { RefObject, useEffect } from "react";

type UseSplitPaneResizeParams = {
  isResizing: boolean;
  splitContainerRef: RefObject<HTMLDivElement>;
  setChatWidthPercent: (value: number) => void;
  setIsResizing: (value: boolean) => void;
  min?: number;
  max?: number;
};

export function useSplitPaneResize({
  isResizing,
  splitContainerRef,
  setChatWidthPercent,
  setIsResizing,
  min = 25,
  max = 75,
}: UseSplitPaneResizeParams): void {
  useEffect(() => {
    if (!isResizing) return;

    const onMove = (e: MouseEvent) => {
      const el = splitContainerRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const pct = ((e.clientX - rect.left) / rect.width) * 100;
      setChatWidthPercent(Math.min(max, Math.max(min, pct)));
    };

    const onUp = () => setIsResizing(false);

    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";

    return () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
  }, [isResizing, max, min, setChatWidthPercent, setIsResizing, splitContainerRef]);
}
